<template>
    <b-modal id="unit_delete" ref="unit_delete" header-class="no-border" footer-class="no-border"
             @hidden="resetForm" :title="'Delete ' + unit.data.attributes.name + '?'">
        <b-row v-if="validationError" class="mb-2">
            <b-colxx md="12">
                <b-alert class="text-center" show variant="danger"
                         v-text="validationError"/>
            </b-colxx>
        </b-row>

        <span>
            You can't revert back your action if you delete this data. For further query, contact Database Manager!
        </span>

        <template slot="modal-footer">
            <b-button size="sm" variant="secondary" @click="hideModal('unit_delete')" v-text="'Cancel'"/>

            <state-button size="sm" variant="danger" :click="deleteUnit">Delete</state-button>
        </template>
    </b-modal>
</template>

<script>
    import StateButton from "../../../../../components/Common/StateButton";

    export default {
        name: "UnitDeleteModal",

        components: {
            StateButton,
        },

        props: [
            'unit',
        ],

        data() {
            return {
                validationError: null
            }
        },

        methods: {
            hideModal(refname) {
                this.$refs[refname].hide();
            },

            deleteUnit() {
                return new Promise((success, fail) => {
                    this.$store.dispatch('deleteUnit', this.unit)
                        .then(response => {
                            setTimeout(() => {
                                success();

                                this.$emit('updated');

                                this.$notify('error filled', 'Success!', 'Deleted the unit!', {
                                    duration: 4000,
                                    permanent: false
                                });

                                this.hideModal('unit_delete');
                            }, 2000);
                        })
                        .catch(error => {
                            if (error.response.data.error) {
                                this.validationError = error.response.data.error;
                            }

                            setTimeout(() => {
                                fail();
                            }, 1000);
                        });
                })
            },

            resetForm() {
                this.validationError = null;
            },
        }
    }
</script>

<style scoped>

</style>
